<template>
  <v-banner
    two-line
    :value="!!deferredPrompt"
  >
    <v-avatar
      slot="icon"
      color="primary"
      size="40"
    >
      <v-icon
        color="white"
      >
        mdi-cellphone-arrow-down
      </v-icon>
    </v-avatar>

    You can launch Vjago from your home screen
    without installing any app

    <template v-slot:actions>
      <v-btn
        text
        color="primary"
        @click="deferredPrompt = null"
      >
        Dismiss
      </v-btn>

      <v-btn
        text
        color="primary"
        @click="addToHomeScreen"
      >
        Add to Home Screen
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
export default {
  data () {
    return {
      deferredPrompt: null
    }
  },
  mounted () {
    window.addEventListener('beforeinstallprompt', (e) => {
      this.deferredPrompt = e
    })
  },
  methods: {
    addToHomeScreen () {
      // Show the prompt
      this.deferredPrompt.prompt()

      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt')
          } else {
            console.log('User dismissed the A2HS prompt')
          }

          this.deferredPrompt = null
        })
    }
  }
}
</script>

<style>

</style>
